import { testimonials, featuredComment } from '@/mocks/homeData';
import AnimatedSection from '@/components/base/AnimatedSection';

export default function TestimonialSection() {
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <AnimatedSection>
        {/* Featured comment - split layout */}
        <div className="flex flex-col lg:flex-row gap-0 mb-20 rounded-2xl overflow-hidden border border-background-200/70">
          {/* Left - Text */}
          <div className="lg:w-[60%] bg-background-100 p-10 md:p-16 flex flex-col justify-center">
            <span className="text-xs font-semibold text-primary-400 mb-6 flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              网友热评
            </span>
            <blockquote className="text-[clamp(1.5rem,3vw,2.5rem)] font-black text-foreground-50 leading-[1.2] tracking-[-0.02em] mb-6">
              <span className="text-primary-500 text-[2em] leading-none">&ldquo;</span>
              {featuredComment.content}
            </blockquote>
            <div className="flex items-center gap-3 mt-4">
              <span className="text-sm font-bold text-foreground-100">
                — {featuredComment.author}
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-verified-badge-fill text-accent-400 text-sm"></i>
                </span>
                <span className="text-xs text-accent-400 font-medium">{featuredComment.role}</span>
              </span>
            </div>
          </div>

          {/* Right - Image */}
          <div className="lg:w-[40%] min-h-[300px] lg:min-h-[500px] relative overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20moody%20silhouette%20of%20a%20person%20looking%20up%20toward%20light%2C%20profile%20view%2C%20mysterious%20anonymous%20figure%2C%20dramatic%20chiaroscuro%20lighting%2C%20noir%20cinematic%20style%2C%20deep%20shadows%2C%20high%20contrast%20black%20and%20white%20aesthetic&width=800&height=600&seq=testimonial-hero&orientation=portrait"
              alt="瓜友评价"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-100 to-transparent lg:bg-gradient-to-r lg:from-transparent lg:to-transparent" />
          </div>
        </div>
        </AnimatedSection>

        <AnimatedSection animation="fade-up">
        {/* Testimonial cards grid */}
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full border border-accent-500/40 text-accent-400 mb-4">
            瓜友评价
          </span>
          <h2 className="text-[clamp(1.8rem,3vw,2.8rem)] font-black text-foreground-50 tracking-[-0.02em]">
            听听瓜友们怎么说
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="p-6 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-500/30 transition-all duration-300"
            >
              {/* Rating stars */}
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span key={star} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-primary-500 text-sm"></i>
                  </span>
                ))}
              </div>

              <p className="text-sm text-foreground-400 leading-relaxed mb-5">
                &ldquo;{t.content}&rdquo;
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-200 truncate">
                    {t.name}
                  </div>
                  <div className="text-xs text-foreground-600 mt-0.5">{t.date}</div>
                </div>
                <span className="px-2 py-0.5 bg-accent-500/15 text-accent-400 text-[10px] font-semibold rounded-full whitespace-nowrap">
                  {t.badge}
                </span>
              </div>
            </div>
          ))}
        </div>
        </AnimatedSection>
      </div>
    </section>
  );
}